export const BUTTON_RADIUS = { SMALL: "small", ROUND: "round" } as const;
export type Radius = (typeof BUTTON_RADIUS)[keyof typeof BUTTON_RADIUS];

export const BUTTON_VARIANT = {
    FILLED: "filled",
    OUTLINED: "outlined",
    GHOST: "ghost",
} as const;
export type Variant = (typeof BUTTON_VARIANT)[keyof typeof BUTTON_VARIANT];

export const BUTTON_COLOR = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
} as const;
export type Color = (typeof BUTTON_COLOR)[keyof typeof BUTTON_COLOR];

export const BUTTON_LAYOUT = { FULL: "full", HUG: "hug" } as const;
export type Layout = (typeof BUTTON_LAYOUT)[keyof typeof BUTTON_LAYOUT];

export const BUTTON_SIZE = {
    SMALL: "small",
    MEDIUM: "medium",
} as const;
export type Size = (typeof BUTTON_SIZE)[keyof typeof BUTTON_SIZE];

export const BUTTON_DRAWING = {
    FILL: "fill",
    STROKE: "stroke",
} as const;

export type Draw = (typeof BUTTON_DRAWING)[keyof typeof BUTTON_DRAWING];
